import React from "react";
import {
  isValid as isDateTimeValid,
  format,
  isWeekend,
  isValid,
} from "date-fns";
import { Button, withStyles } from "@material-ui/core";
import CancelButton from "../components/Buttons/CancelButton";
import Footer from "../components/Footer";
import { redirectToIBPlanning } from "../utils";
import { getTerminalDateByOffset } from "../../Dispatch/utils/utils";
import { compose } from "recompose";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { getDataWithQueryString } from "./../../../../api/componentAPIs";
import CustomConfirmationDialog from "../../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog";
import { getHolidayName, isHoliday, isPastDate } from "./utils";
import { withPlanDate } from "../PlanDateContext";
import { withSelectedDateHoc } from "./SelectedDateHoc";

const styles = (theme) => ({
  container: {
    height: "100%",
  },
  dateContainer: {
    display: "flex",
    alignItems: "center",
    padding: 32,
    justifyContent: "center",
  },
  label: {
    marginRight: 16,
    paddingTop: 8,
    color: theme.HeaderSelectedText,
    fontWeight: 600,
    fontSize: 14,
  },
  actionButton: {
    textTransform: "none",
    "&$actionDisabled": {
      backgroundColor: theme.headerIconColor,
      color: theme.TextColor,
      cursor: "not-allowed",
      opacity: 0.7,
    },
  },
  actionDisabled: {
    backgroundColor: theme.iconColor,
    color: "black",
  },
  confirmText: {
    color: theme.gridTextColor,
  },
});

class PlanDateForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initializedDates: [],
      holidays: [],
      showHolidayWarning: false,
    };
  }

  componentDidMount() {
    this.loadInitializedPlanDates();
    this.loadHolidays();
  }

  loadInitializedPlanDates = () => {
    const {
      userData: { userProfile },
    } = this.props;
    getDataWithQueryString(
      "GetInitializedPlanDates",
      `terminalId=${userProfile.terminal.id}`
    ).then((response) => {
      if (response?.status === 200) {
        this.setState({
          initializedDates: response.data,
        });
      }
    });
  };

  loadHolidays = () => {
    const {
      userData: { userProfile },
    } = this.props;
    getDataWithQueryString(
      "GetValidHolidays",
      `terminalCode=${userProfile.terminal.code}`
    ).then((response) => {
      if (response?.status === 200) {
        this.setState({
          holidays: response.data,
        });
      }
    });
  };

  handleNext = () => {
    const { holidays, initializedDates } = this.state;
    if (
      isHoliday(this.props.selectedDate, holidays) &&
      !this.props.checkPlanAlreadyInitialized(
        this.props.selectedDate,
        initializedDates
      )
    ) {
      this.setState({
        showHolidayWarning: true,
      });
      return;
    }
    this.handleConfirm();
  };

  getTerminalDate = () => {
    const {
      userData: { userProfile },
    } = this.props;
    return new Date(
      getTerminalDateByOffset(new Date(), userProfile.terminal.offset)
    );
  };

  cancelPlan = () => {
    this.setState({
      showHolidayWarning: false,
    });
  };

  handleConfirm = () => {
    const planDate = this.props.getPlanDateChangedParams();
    this.props.handlePlanDateChanged(...planDate);
  };

  isActionButtonDisabled = () => {
    const terminalDate = this.getTerminalDate();
    if (this.props.showDateRange) {
      return (
        !isValid(this.props.selectedDate[0]?.endDate) ||
        isPastDate(this.props.selectedDate[0]?.endDate, terminalDate)
      );
    }
    return (
      !this.props.selectedDate ||
      isPastDate(this.props.selectedDate, terminalDate)
    );
  };

  render() {
    const { classes, selectedDate} = this.props;
    const terminalDate = this.getTerminalDate();
    const dateInWords = format(selectedDate, "do MMMM");
    const dayOfWeekInWords = format(selectedDate, "EEEE");
    return (
      <>
        <div className={classes.container}>
          <div className={classes.dateContainer}>
            {this.props.getDateComponent({
              terminalDate,
              holidays: this.state.holidays,
              initializedDates: this.state.initializedDates
            })}
          </div>
        </div>
        {this.state.showHolidayWarning && (
          <CustomConfirmationDialog
            title={`${dateInWords} (${
              isWeekend(selectedDate)
                ? dayOfWeekInWords
                : getHolidayName(selectedDate, this.state.holidays)
            }) is a holiday.`}
            cancelButtonLabel="Cancel"
            confirmButtonLabel="Create Plan"
            onConfirm={this.handleConfirm}
            onCancel={this.cancelPlan}
          >
            <div
              className={classes.confirmText}
            >{`Are you sure you want to create a plan for ${dateInWords}?`}</div>
          </CustomConfirmationDialog>
        )}
        <Footer>
          <CancelButton onClick={redirectToIBPlanning} />
          <Button
            classes={{
              root: classes.actionButton,
              disabled: classes.actionDisabled,
            }}
            onClick={this.handleNext}
            disabled={this.isActionButtonDisabled()}
            variant="contained"
            color="primary"
          >
            {this.props.checkPlanAlreadyInitialized(
              selectedDate,
              this.state.initializedDates
            )
              ? "Update Plan"
              : "Add Plan"}
          </Button>
        </Footer>
      </>
    );
  }
}

export default compose(
  withPlanDate,
  withUserProfile,
  withSelectedDateHoc,
  withStyles(styles)
)(PlanDateForm);
